import {Component, inject, Input} from "@angular/core";
import {Store} from "@ngrx/store";
import {selectSelectedDeal, selectSelectedDealCashFlowsErrorMsg, selectSelectedDealIsNotInit} from "../../store/deal/deal.selectors";

@Component({
    selector: "valumize-deal-cashflows",
    templateUrl: "./deal-cashflows.component.html",
    standalone: false
})
export class DealCashflowsComponent {
    private readonly store = inject(Store);

    @Input() isSensitivityView = false;

    displaySecondaryColumns = false;
    displayPatternColumns = false;
    displayHurdleColumns = false;

    selectedDeal$ = this.store.select(selectSelectedDeal);
    selectedDealIsNotInit$ = this.store.select(selectSelectedDealIsNotInit);
    errorMsg$ = this.store.select(selectSelectedDealCashFlowsErrorMsg);

    constructor() {
    }

    toggleSecondaryColumns() {
        this.displaySecondaryColumns = !this.displaySecondaryColumns;
    }

    togglePatternColumns() {
        this.displayPatternColumns = !this.displayPatternColumns;
    }

    toggleHurdleColumns() {
        this.displayHurdleColumns = !this.displayHurdleColumns;
    }
}
